import role, { partnerAdmin } from './roles';
import accessType from './accessType';

const access = {
   getAdminAccessByApp: {
      jobFeed: {
         type: accessType.role,
         value: {
            partner: [...partnerAdmin.jobFeed],
         },
      },
      synJobFeed: {
         type: accessType.role,
         value: {
            partner: [...partnerAdmin.synJobFeed],
         },
      },
      synSites: {
         type: accessType.role,
         value: {
            partner: [...partnerAdmin.synSites],
         },
      },
      manageAlert: {
         type: accessType.role,
         value: {
            partner: [...partnerAdmin.manageAlert],
         },
      },
      syndicatedSponsoredAds: {
         type: accessType.role,
         value: {
            partner: [...partnerAdmin.syndicatedSponsoredAds],
         },
      },
      syndicatedJobs: {
         type: accessType.role,
         value: {
            partner: [
               role.partner.admin,
               role.partner.syndicatedSitesPartnerInternal,
            ],
         },
      },
      sponsoredAds: {
         type: accessType.role,
         value: {
            partner: [...partnerAdmin.sponsoredAds],
         },
      },
   },
   generate: {
      fieldAccess: (privilegeStr) => ({
         type: accessType.privilege,
         value: privilegeStr,
      }),
      roleAccess: ({ employer, partner }) => ({
         type: accessType.role,
         value: {
            employer,
            partner,
         },
      }),
   },
   type: {
      ...accessType,
   },
   isPublic: {
      type: accessType.public,
   },
   byRole: {
      employer: {
         all: {
            type: accessType.role,
            value: {
               employer: [...role.employer.all],
            },
         },
         onlyAdmin: {
            type: accessType.role,
            value: {
               employer: [role.employer.admin],
            },
         },
      },
      partner: {
         all: {
            type: accessType.role,
            value: {
               partner: [...role.partner.all],
            },
         },
         onlyAdmin: {
            type: accessType.role,
            value: {
               partner: [role.partner.admin],
            },
         },
      },
   },
};

export default access;
